/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Antenna} from "../models/antenna";
import {AntennaService} from "../services/antenna.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update

export class AntennasPagingResolver implements Resolve<PagedResults<Antenna>> {

  constructor(
    private mAntennaService: AntennaService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Antenna>> {
    try {
      return await this.mAntennaService.getAllAntennasForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Antennas... Error: " + error, error);
    }
  }

}
